import React, { useState } from "react";
import axios from "axios";
import Wrapper from "../../../style/wrappers/RegisterPage.js";
import { Navbar } from "../../../commn/Navbar.js";
import { Link, useNavigate } from "react-router-dom";

export const InternshipVideoAdd = () => {
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const newVideo = {
      name,
      url,
    };

    // Correct usage of localStorage.getItem('user')
    const user = JSON.parse(localStorage.getItem("user"));

    axios
      .post("/api/internshipvideo/add", newVideo, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + (user ? user.token : ""), // Ensure user.token is accessed safely
        },
      })
      .then((res) => {
        alert("Successfully Added");
        navigate("/Ainternshipvideodisplay");
      })
      .catch((err) => {
        console.error("Error adding video: ", err);
      });
  };

  return (
    <div>
      <Navbar />
      <Wrapper className="mt-5">
        <div className="text-center">
          <Link to="/Ainternshipvideodisplay">
            <button className="btn btn-primary">Internship Videos</button>
          </Link>
        </div>
        <form
          className="form"
          onSubmit={handleSubmit}
          style={{ marginTop: "5%" }}
        >
          <h3>Add Internship Video</h3>
          <div className="form-row">
            <label className="form-label">Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="form-input"
            />
          </div>
          <div className="form-row">
            <label className="form-label">Video Link</label>
            <input
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className="form-input"
            />
          </div>
          <button type="submit" className="btn btn-block">
            Submit
          </button>
        </form>
      </Wrapper>
    </div>
  );
};
